enum Broker {
  NONE = '',
  TRADIER = 'tradier',
  TDAMERITRADE = 'tdameritrade',
  TRADESTATION = 'tradestation'
}

export default Broker
